import '../App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import About from './About'
import Experience from './Experience'
import Education from './Education'
import Skills from './Skills'
import Interests from './Interests'
import Awards from './Awards'
import Certifications from './Certifications'
import Projects from './Projects'


const Main = () => {
    return (
        <div id="page-top">
            <BrowserRouter>
                <Switch>
                    <Route path="/" exact component={About} />
                    <Route path="/experience" exact component={Experience} />
                    <Route path="/education" exact component={Education} />
                    <Route path="/skills" exact component={Skills} />
                    <Route path="/interests" exact component={Interests} />
                    <Route path="/awards" exact component={Awards} />
                    <Route path="/certifications" exact component={Certifications} />
                    <Route path="/projects" exact component={Projects} />
                </Switch>
            </BrowserRouter>
        </div>
    );
}

export default Main
